var _PhotoUploadCommand_instances, _PhotoUploadCommand_readData, _PhotoUploadCommand_isValidFile;
import { __classPrivateFieldGet } from "tslib";
import axios from 'axios';
import { SessionService } from '../../../service/SessionService';
export class PhotoUploadCommand {
    constructor() {
        _PhotoUploadCommand_instances.add(this);
    }
    async execute(file) {
        if (!file || !__classPrivateFieldGet(this, _PhotoUploadCommand_instances, "m", _PhotoUploadCommand_isValidFile).call(this, file)) {
            console.error('invalid files');
            return;
        }
        const base64 = await __classPrivateFieldGet(this, _PhotoUploadCommand_instances, "m", _PhotoUploadCommand_readData).call(this, file);
        const uri = 'https://mycast.xyz:9011/photo';
        const privKey = SessionService.getPrivateKey();
        try {
            const { data } = await axios.post(uri, { base64, privKey });
            return data;
        }
        catch (e) {
            console.error(e);
            return null;
        }
    }
}
_PhotoUploadCommand_instances = new WeakSet(), _PhotoUploadCommand_readData = async function _PhotoUploadCommand_readData(file) {
    return new Promise((resolve) => {
        const fileReader = new FileReader();
        fileReader.onload = (_) => {
            if (typeof fileReader.result === 'string') {
                const base64 = fileReader.result;
                resolve(base64);
            }
        };
        fileReader.readAsDataURL(file);
    });
}, _PhotoUploadCommand_isValidFile = function _PhotoUploadCommand_isValidFile(file) {
    if (!file || !file.type.includes('image')) {
        return false;
    }
    return true;
};
